import { Stack } from "@mantine/core";
import { HeldEmailQueueViewModel } from "./heldEmailQueueViewModel";
import { HeldEmailQueueDetailForView } from "./HeldEmailQueueDetailForView";
import { HeldEmailQueueDialogsForView } from "./HeldEmailQueueDialogsForView";
import { HeldEmailQueuePaginationForView } from "./HeldEmailQueuePaginationForView";

export function HeldEmailQueueSecondaryView({
  model,
}: {
  model: HeldEmailQueueViewModel;
}) {
  return (
    <Stack gap="md">
      <HeldEmailQueuePaginationForView model={model} />
      <HeldEmailQueueDetailForView model={model} />
      <HeldEmailQueueDialogsForView model={model} />
    </Stack>
  );
}
